import { type Context, type Dispatch, createContext } from 'react';

import { SelectReducerAction } from '../state/select-menu-state-reducer.js';

export interface SelectMenuContextProps {
  state: boolean;
  dispatch: Dispatch<SelectReducerAction>;
  announcementText: string;
  setAnnouncementText: (text: string) => void;
}

export const initialState = false;

/** SelectMenu context, used to access the state and dispatcher in other components. */
export const SelectMenuContext: Context<SelectMenuContextProps> =
  createContext<SelectMenuContextProps>({
    state: initialState,
    dispatch: () => null,
    announcementText: '',
    setAnnouncementText: () => null,
  });
